export const SYSTEM_JOB_STATUS_BADGE = {
  SUCCESS: { text: 'Succeeded', color: 'success' },
  RUNNING: { text: 'Running', color: 'info' },
  FAILED: { text: 'Failed', color: 'danger' },
  PENDING_ASSET_REPORT: { text: 'Pending Asset Report', color: 'warning' },
  QUEUE: { text: 'In Queue', color: 'warning' },
};

export const SYSTEM_JOB_TYPE = {
  FINCH_SYNC: 'Finch sync',
  REWARDS_PROCESS: 'Rewards',
  MONTHLY_BRIDGEPOINTS: 'Monthly BridgePoints grant',
  TABAPAY_REPORTS: 'TabaPay daily reconcilliation',
};
